import { max } from 'd3';
import { useEffect } from 'react';
import { ChartSpacing } from '../util/spacing';

const ESTIMATED_AXIS_TEXT_SIZE = 6;

export const useDynamicLeftAxisSpacing = (
  yValues: [string, number][],
  spacing: ChartSpacing,
  setSpacing: (spacing: ChartSpacing) => void,
  additionalLeftAxisPadding = 10,
) => {
  // given the yValues - estimate the size of the label (works because we use monospace fonts)
  // and add on some additional padding. If it's different, change the chart spacing.
  useEffect(() => {
    const leftTextSize: number | undefined = max(
      yValues,
      y => y[0].length * ESTIMATED_AXIS_TEXT_SIZE,
    );
    const dynamicSpacing = {
      ...spacing,
      left: leftTextSize ? leftTextSize + additionalLeftAxisPadding : spacing.left,
    };
    if (dynamicSpacing.left !== spacing.left) {
      setSpacing(dynamicSpacing);
    }
  }, [yValues, setSpacing, spacing, additionalLeftAxisPadding]);
};
